import showFlash from "flash-message";

(function() {
    import("angular").then(angular => {
        var app = angular.module("tapAssetManager");

        app.factory("assetPatcher", [
            "assetStorage",
            function(assetStorage) {
                return {
                    remove: function(assets, cb) {
                        if (assets.constructor !== Array) {
                            assets = [assets];
                        }

                        var patches = [];
                        angular.forEach(assets, function(asset) {
                            asset.isUpdating = true;
                            patches.push({
                                op: "remove",
                                path: "/" + asset.id + "/",
                            });
                        });

                        assetStorage.patch(patches, function(err, results) {
                            angular.forEach(assets, function(asset) {
                                assetStorage.removeItem(asset);
                            });
                            cb(err, results);
                        });
                    },
                    replace: function(assets, prop, value, cb) {
                        var options = options || {};

                        if (assets.constructor !== Array) {
                            assets = [assets];
                        }

                        var patches = [];
                        angular.forEach(assets, function(asset) {
                            patches.push({
                                op: "replace",
                                path: "/" + asset.id + "/" + prop + "/",
                                value: value,
                            });
                        });

                        if (patches.length === 0) return;

                        assetStorage.patch(patches, function(err, results) {
                            if (err) showFlash("danger", "An unknown error occurred");
                            cb(err, results);
                        });
                    },
                    add: function(assets, prop, value, cb) {
                        var options = options || {};

                        if (assets.constructor !== Array) {
                            assets = [assets];
                        }

                        var patches = [];
                        angular.forEach(assets, function(asset) {
                            patches.push({
                                op: "add",
                                path: "/" + asset.id + "/" + prop + "/",
                                value: value,
                            });
                        });

                        if (patches.length === 0) return;

                        assetStorage.patch(patches, function(err, results) {
                            if (err) showFlash("danger", "An unknown error occurred");
                            cb(err, results);
                        });
                    },
                    getErrors: function(results) {
                        var errors = [];
                        angular.forEach(results, function(result) {
                            if (result.status !== 200 && errors.indexOf(result.message) === -1) {
                                errors.push(result.message);
                            }
                        });

                        return errors.length > 0 ? errors : null;
                    },
                };
            },
        ]);
    });
})();
